import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {StorageService} from "@portal/shared/services/storage.service";
import {AuthService} from "../../../../../core/auth/auth.service";
import {Router} from "@angular/router";
import {MatDialog} from "@angular/material/dialog";
import {GenericDialogComponent} from "@portal/shared/generic-dialog/generic-dialog.component";
import {CatalogProductsService} from "@portal/api/catalog-products.service";
import {PartyResponse} from "@portal/api/responses/Parties/party-response";
import {Org} from "@portal/api/responses/organizations/org-details-response";

@Component({
    selector: 'app-quote-request',
    templateUrl: './quote-request.component.html',
    styleUrls: ['./quote-request.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class QuoteRequestComponent implements OnInit {
    isSubmitting = false;
    quoteItems = [];
    party: PartyResponse;
    org: Org;
    formData = {
        name: '',
        email: '',
        phone: '',
        message: ''
    };

    constructor(
        private _storageService: StorageService,
        private authService: AuthService,
        private router: Router,
        private dialog: MatDialog,
        private _catalogProductsService: CatalogProductsService
    ) {
    }

    ngOnInit(): void {
        this.party = this._storageService.getParty();
        this.org = this._storageService.getOrg();
        this.quoteItems = this._storageService.getQuoteItems();
        if (this.quoteItems.length === 0) {
            this.router.navigate([this.catalogRoute]);
        }
    }

    isLoggedIn(): boolean {
        return !!this.authService.isAuthenticated;
    }

    submitQuote(): void {

        this.isSubmitting = true;

        const payload = {
            products: this.quoteItems,
            ...this.formData
        };

        this._catalogProductsService.quoteCatalog(payload).subscribe(
            {
                next: () => {
                    this.isSubmitting = false;
                    this._storageService.clearQuoteItems();

                    this.dialog.open(GenericDialogComponent, {
                        width: '400px',
                        data: {
                            title: 'Pedido enviado com sucesso!',
                            message: 'Obrigado pelo seu pedido de orçamento. Entraremos em contacto o mais breve possível.',
                            confirmText: 'Voltar ao catálogo'
                        }
                    }).afterClosed().subscribe(result => {
                        if (result === 'confirm') {
                            this.router.navigate([this.catalogRoute]);
                        }
                    });
                },
                error: () => {
                    this.isSubmitting = false;
                    this.dialog.open(GenericDialogComponent, {
                        width: '400px',
                        data: {
                            title: 'Ocorreu um erro',
                            message: 'Por favor tente de novo ou envie um email para suporte@organiza360.pt!',
                            confirmText: 'Ok'
                        }
                    });
                }
            });
    }

    get totalItems(): number {
        return this.quoteItems.reduce((total, item) => total + item.quantity, 0);
    }

    get contextName(): string {
        return this.party?.name || this.org?.name || 'Organiza360';
    }

    get catalogRoute(): string {
        return this.isLoggedIn() ? '/catalog' : '/product-catalog';
    }
}
